module.exports = __webpack_public_path__ + "static/media/dark.25df9709.jpg";